import { render, staticRenderFns } from "./FooterDark.vue?vue&type=template&id=073ae4ed&shadow"
import script from "./FooterDark.vue?vue&type=script&lang=js&shadow"
export * from "./FooterDark.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports